import React, {useState} from 'react';
import Dropzone from 'react-dropzone';
import { Controller } from 'react-hook-form';
import styles from "./form.module.scss";
import {fileNameFormatter, fileSizeFormatter} from "../../utils/utils";

const DropInput = ({ control, name, error, inTimeValue, text }) => {
  const [dragActive, setDragActive] = useState(false);

  const onDragEnter = () => {
    setDragActive(true);
  }

  const onDragLeave = () => {
    setDragActive(false);
  }

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={[]}
      render={({field: {onChange, onBlur, value}}) => (
        <>
          <Dropzone
            onDrop={onChange}
            onDragStart={onDragEnter}
            onDragOver={onDragEnter}
            onDragLeave={onDragLeave}
          >
            {
              ({ getRootProps, getInputProps}) => (
                <div
                  className={`
                    ${styles.dragAndDrop} ${dragActive ? styles.active : ''}
                    ${error ? styles.error : inTimeValue?.length > 0 && !error ? styles.complete : ''}
                  `}
                  {...getRootProps()}
                >
                  <div className={styles.clip}></div>
                  <span className={styles.dragText}>
                    { value?.[0]?.name ? fileNameFormatter(value?.[0].name, 12) : `+ ${text}`}
                    <span className={styles.size}>{value?.[0]?.size ? `${fileSizeFormatter(value?.[0]?.size)} MB` : ``}</span>
                  </span>

                  <input
                    name={name}
                    onBlur={onBlur}
                    {...getInputProps()}
                  />
                </div>
              )
            }
          </Dropzone>
        </>
      )
      }
    />
  );
};

export default DropInput;